<template>



    <header v-bind:class="{navActive:navshow}">
        <div class="bg-primary-orange text-white p-3 text-sm text-center">
            <div class="veranstalterlogo">
                <img src="https://api.pgsi2020.de/img/salesianer_logo.png">
            </div>
            <div class="veranstalter inline-block lg:text-xl">
                31. International Salesian Youth Games | 28.04. - 03.05.2020 | Duisburg, Germany
            </div>
            <div class="veranstalterlogo">
                <img src="https://api.pgsi2020.de/img/pgsi_logo.png">
            </div>
            <!--div v-for="veranstalterItem in veranstalter[0]" :key="veranstalter.ID" v-if="veranstalterItem.sponsorlogo" class="veranstalter inline-block">
                <a v-bind:href="veranstalterItem.sponsorlink" target="_blank">
                    <img :src="veranstalterItem.sponsorlogo">
                </a>
            </div-->
        </div>

        <div class="grid grid-columns-12 pt-4 relative">
            <div class="col-span-3 inline-block flag pt-3 pl-2">
                <div class="langflag">
                    <div class="langflag__en" @click="langEN"></div>
                    <div class="langflag__de" @click="langDE"></div>
                </div>
            </div>
            <div class="col-span-6 image">
                <div class="text-center">
                    <router-link to="/">
                        <img alt="PGSI 2020" src="https://api.pgsi2020.de/images/logo.png" class="inline-block">
                    </router-link>
                </div>
            </div>
            <div class="col-span-3  pt-3 pl-2 pr-2 el3" @click="navshow=true">
                <div class="hamburger" v-bind:class="{ isSticky: sticky }">
                    <div class="topping bg-primary-red"></div>
                    <div class="topping bg-primary-orange"></div>
                    <div class="topping bg-primary-blue"></div>
                    <div class="topping bg-primary-green"></div>
                </div>
            </div>
        </div>
        <seperator :css="'-mt-6'"/>
        <nav class="p-5">
            <div class="close" @click="navshow=false"></div>
            <div v-for="navItems in navigation" :key="navItems.ID" class="text-xl pt-3 mt-5 clear-both">
                <main-navi :navigation="navItems" />
                <!--sub-navi :subItem="navItems.sub" /-->
            </div>
        </nav>
    </header>
</template>


<script>

    import seperator from '../seperator'
    import TheLanguage from '../TheLanguage'
    import subNavi from './sub'
    import mainNavi from './main'
    import { serverBus } from '../../main';

    export default {
        components: {
            seperator,
            TheLanguage,
            subNavi,
            mainNavi
        },
        data() {
            return {
                navigation: [],
                veranstalter: [],
                navshow: false,
                scrollY: null,
                sticky: false,
                myStyle: {},
                originalTop: 0
            }
        },
        computed: {

        },
        created: function(){

            const baseURI = 'https://api.pgsi2020.de/api/file/navigation.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.navigation = result.data
                })


            const veranstalterURI = 'https://api.pgsi2020.de/api/file/veranstalter.json'
            this.$http.get(veranstalterURI)
                .then((veranstalter) => {
                    this.veranstalter = veranstalter.data
                })



                serverBus.$on('shownav', ( inputValue ) => {
                    this.navshow = false;
                })
        },
        mounted() {
            window.addEventListener('scroll', (event) => {
                this.scrollY = Math.round(window.scrollY);
            });
        },
        watch: {
            scrollY(newValue) {
                const newTop = this.scrollY;
                if (newTop > 60) {
                    this.sticky = true;
                } else {
                    this.sticky = false;
                }
            },
            navshowState(newValue) {
                if (newValue === false) {
                    this.navshow = false;
                }
            }
        },
        methods: {
            langEN(){
                this.$store.commit('language', true);
            },
            langDE(){
                this.$store.commit('language', false);
            }
        }

    }
</script>


<style lang="scss" scoped>
    .clear-both{
        clear: both;
    }
    .langflag{
        width: 63px;
        height: 31px;
        background-image: url('https://api.pgsi2020.de/images/lang_flag.png');
        background-repeat: no-repeat;
        transition: background-position ease-in-out 0.2s;
        transform: scale(.6);
        .langEN &{
            background-position: -63px 0;
        }
        .langflag__de,
        .langflag__en{
            width: 63px;
            height: 31px;
            background: transparent;
        }
        .langflag__en{
            .langEN &{
                display: none;
            }
        }
        .langflag__de{
            display: none;
            .langEN &{
                display: block;
            }

        }
    }
    .nav-grid{
        display: -ms-grid;
        display: grid;
        grid-template-columns: 20% 60% 20%;
        -ms-grid-columns: 20% 60% 20%;
    }
    .image{
        img{
            width: 50%;
            max-width: 120px;
        }
        //-ms-grid-column: 2;
        //grid-column: 2;
    }
    .flag{
        img{
            width: 30px;
        }
        //-ms-grid-column: 1;
        //grid-column: 1;
    }
    .el3{
        //-ms-grid-column: 3;
        //grid-column: 3;
        text-align: right;
    }
    .hamburger{
        display: inline-block;
        font-size: 0;
        max-width: 60px;
        width: 100%;

        &.isSticky{
            position: fixed;
            top: 18px;
            right: 8px;
        }
        right: 0;
        z-index: 100;
        background: rgba(255,255,255,0.5);
        padding: 5px 12px 5px 0;
        cursor: pointer;

        .topping{
            width: 90%;
            height: 5px;
            margin-bottom: 4px;
            display: inline-block;
            transition: all ease-in-out .2s;
            &:nth-child(0){
                width: 100%;
            }
            &:nth-child(1){
                width: 90%;
            }
            &:nth-child(2){
                width: 80%;
            }
            &:nth-child(3){
                width: 70%;
            }
            &:nth-child(4){
                width: 60%;
            }
            .navActive &{
                width: 100% !important;
            }
        }
        &:hover{
            .topping{
                &:nth-child(0){
                    width: 60%;
                }
                &:nth-child(1){
                    width: 70%;
                }
                &:nth-child(2){
                    width: 80%;
                }
                &:nth-child(3){
                    width: 90%;
                }
                &:nth-child(4){
                    width: 100%;
                }
            }
        }
    }

    nav{
        position: fixed;
        z-index: 99999;
        transition: all ease-in-out .2s;
        width: 0;
        height: 0;
        left: 100vw;
        top: -100vh;
        border-bottom-left-radius: 0;
        opacity: 0;
        &:after{
            content: '';
            position: fixed;
            z-index: -1;
            transition: all ease-in-out .6s;
            width: 0;
            height: 0;
            left: 100vw;
            top: -100vh;
            border-bottom-left-radius: 0;
            opacity: 0;
            @apply bg-primary-red;
        }
        &:before{
            content: '';
            position: fixed;
            z-index: -2;
            transition: all ease-in-out .4s;
            width: 0;
            height: 0;
            left: 100vw;
            top: -100vh;
            border-bottom-left-radius: 0;
            opacity: 0;
            @apply bg-primary-blue;
        }
        .navActive &{
            border-bottom-left-radius: 900px;
            top: 0;
            left: -55vw;
            width: 155vw;
            height: 100vh;
            padding-bottom: 10vh;
            opacity: 1;
            padding-left: 59vw;
            overflow-y: scroll;
            &:after{
                border-bottom-left-radius: 900px;
                top: 0;
                left: -55vw;
                width: 155vw;
                height: 120vh;
                opacity: 1;
                padding-left: 59vw;
            }
            &:before{
                border-bottom-left-radius: 900px;
                top: 0;
                left: -55vw;
                width: 155vw;
                height: 120vh;
                opacity: 1;
                padding-left: 59vw;
            }
        }
        @apply bg-primary-orange text-white;
        ul{
            li{
                font-weight: 900;
                border-bottom: 2px solid #FFF;
            }
        }
    }


    .close{
        position: absolute;
        right: 10px;
        top: 15px;
        width: 20px;
        height: 20px;
        &:after,
        &:before{
            position: absolute;
            left: 0px;
            content: ' ';
            height: 20px;
            width: 2px;
            background-color: #FFF;
        }
        &:after{
            transform: rotate(45deg);
        }
        &:before{
            transform: rotate(-45deg);
        }
        &.close--small{
            &:after,
            &:before{
                height: 15px;
                background-color: #FFF;
            }
        }
    }

    .organizer{
        text-align: left;
        background: #8EE8C7;
        padding: 5px;
        div{
            display: inline-block;
            max-width: 20%;
            max-height: 100px;
            padding-right: 5px;
            vertical-align: middle;
            img{
                max-height: 100px;
            }
        }
    }

    .veranstalter {
        display: inline-block;
        width: 80%;
        vertical-align: middle;
        padding-right: 10px;
        img{
            max-height: 60px;
        }
    }


    .veranstalterlogo{
        display: inline-block;
        vertical-align: middle;
        width: 9%;
        img{
            width: 90%;
        }
    }

</style>
